export function getImagePositionStyles(coords) {
  const styles = {
    position: "absolute",

    width: "fit-content",
    height: "fit-content",
    "background-position": "unset",

    transform: `scale(${coords.scale ? coords.scale : 100}%) rotate(${
      coords.rotate ? coords.rotate : 0
    }deg)`,

    inset: `${coords.y}% ${-coords.x}% ${-coords.y}% ${coords.x}% !important`,

    "z-index": coords.zIndex,
  };

  return styles;
}
